<template>
    <footer class="footer">
        <div class="footer-container">
            <!-- 左侧品牌信息 -->
            <div class="footer-brand">
                <div class="brand-logo">
                    <img src="@/assets/images/logo.png" alt="点云研智网" />
                </div>
                <p class="brand-slogan">专业3D定制服务与点云数字资产交易平台</p>
                <div class="brand-copyright">
                    <span>© 2020-2026 点云研智网：pointcloudyzw.com</span><br>
                    <span>合肥中研智设科技有限公司 All rights reserved</span>
                </div>
                <div class="icp-info">
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">皖ICP备2026022027号</a>
                    <!-- <span class="license-info">增值电信业务经营许可证: 湘B2-20230751</span> -->
                    <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener">皖公网安备34019202003088号</a>
                </div>
            </div>
            <!-- 导航栏目循环 -->
            <div class="nav-column" v-for="(column, index) in navColumns" :key="index">
                <h3 class="nav-title">{{ column.title }}</h3>
                <ul class="nav-list">
                    <li v-for="(link, i) in column.links" :key="i">
                        <a :href="link.url" target="_blank">{{ link.text }}</a>
                    </li>
                </ul>
            </div>

            <!-- 右侧社交媒体 -->
            <div class="footer-social">
                <div class="social-item" v-for="(social, index) in socialLinks" :key="index">
                    <div class="social-icon" :class="social.class">
                        <i :class="social.icon"></i>
                    </div>
                    <span class="social-label">{{ social.label }}</span>
                    <div class="scan-box" v-if="social.scanItems && social.scanItems.length">
                        <div class="scan-arrow"></div>
                        <div class="scan-content">
                            <div class="scan-item" v-for="(item, idx) in social.scanItems" :key="idx">
                                <img :src="item.img" :alt="item.text">
                                <a v-if="item.link" :href="item.link" target="_blank" rel="noopener">{{ item.text }}</a>
                                <p v-else>{{ item.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterBox',
    data() {
        return {
            navColumns: [
                {
                    title: '官方合作单位',
                    links: [
                        { text: '三维软硬件开发单位', url: 'https://www.szytsz.com' },
                    ]
                },
                {
                    title: '3D模型库',
                    links: [
                        { text: '免费模型', url: '/model?type=free' },
                        { text: '全部模型', url: '/model' }
                    ]
                },
                {
                    title: '3D点云',
                    links: [
                        { text: '免费点云', url: '/scene?type=free' },
                        { text: '全部点云', url: '/scene' }
                    ]
                },
                // {
                //     title: '教程',
                //     links: [
                //         { text: '热门课程推荐', url: '/tutorial/recommended' },
                //         { text: '免费课程', url: '/tutorial?type=free' },
                //         { text: '全部课程', url: '/tutorial' },
                //         { text: '学习专题', url: '/tutorial/topics' },
                //         { text: '练习档案', url: '/tutorial/practice' }
                //     ]
                // },
                // {
                //     title: '发现',
                //     links: [
                //         { text: '发现/推荐', url: '/discover' },
                //         { text: '摘选', url: '/discover/selection' },
                //         { text: '光点/热报', url: '/discover/highlight' },
                //         { text: '点云研智网资讯', url: '/news' }
                //     ]
                // },
                {
                    title: '3D定制作品库',
                    links: [
                        { text: '首推作品', url: '/product-detail/55' },
                        { text: '优秀作品', url: '/product-detail/58' },
                        { text: '全部作品', url: '/product' },
                    ]
                },
                {
                    title: '支持服务',
                    links: [
                        { text: '关于点云研智网', url: '/about' },
                        { text: '联系我们', url: '/contact' },
                        { text: '意见反馈', url: '/feedback' },
                        { text: '侵权申诉', url: '/report' },
                        { text: '帮助中心', url: '/help' }
                    ]
                }
            ],
            socialLinks: [
                {
                    icon: 'ri-wechat-fill',
                    class: 'wechat',
                    label: '点云研智网官方服务号',
                    scanItems: [
                        { img: require('@/assets/images/CGmodel_subscription_bottom.jpg'), text: '点云研智网订阅号' },
                        { img: require('@/assets/images/QC.jpg'), text: '点云研智网服务号' }
                    ]
                },
                {
                    icon: 'ri-weibo-fill',
                    class: 'weibo',
                    label: '点云研智网官方微信号',//原微博号
                    scanItems: [
                        {
                            img: require('@/assets/images/customer-weibo-service.png'),
                            text: '点云研智网微信号',
                            // text: '@点云研智网微信号',
                            // link: 'https://weibo.com/u/2679348333'
                        }
                    ]
                },
                {
                    icon: 'ri-bilibili-fill',
                    class: 'bilibili',
                    label: '点云研智网官方抖音号',//原B站号
                    scanItems: [
                        {
                            img: require('@/assets/images/customer-bilibili-service-scan.png'),
                            text: '点云研智网抖音',
                            // text: '@点云研智网抖音',
                            // link: 'https://space.bilibili.com/69910450'
                        }
                    ]
                }
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.footer {
    height: auto;
    border-top: 6px solid #0092ff;
    width: 100%;

    .footer-container {
        max-width: 1326px;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .footer-brand {
            flex-shrink: 0;
            max-width: 280px;

            .brand-logo {
                width: 100%;
                height: 40px;
                color: #B62726;
                margin-bottom: 16px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }
            }

            .brand-slogan {
                color: #DFDFDF;
            }

            .brand-copyright {
                font-size: 12px;
                color: #777777;
                margin: 20px 0 10px;
                line-height: 18px;
            }

            .icp-info {
                display: flex;
                flex-direction: column;
                row-gap: 5px;

                a,
                span {
                    font-size: 12px;
                    color: #404040;
                    line-height: 16px;
                    text-decoration: none;
                }
            }
        }

        .nav-column {
            .nav-title {
                font-size: 16px;
                font-weight: 500;
                color: #fff;
                margin: 0 0 20px;
            }

            .nav-list {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    margin-bottom: 12px;

                    a {
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.5);
                        text-decoration: none;
                        transition: color 0.3s ease;
                        display: inline-block;

                        &:hover {
                            color: rgba(255, 255, 255, 0.9);
                        }
                    }
                }
            }
        }

        .footer-social {
            flex-shrink: 0;
            display: flex;
            gap: 15px;

            .social-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;

                .social-icon {
                    background-color: #1A1A1A;
                    width: 70px;
                    height: 45px;
                    color: #DDD;
                    border-radius: 8px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 10px;
                    transition: background-color 0.3s ease;

                    i {
                        font-size: 26px;
                        color: #fff;
                        transition: color 0.3s ease;
                    }

                    &.wechat:hover i {
                        color: #2dc47f;
                    }

                    &.weibo:hover i {
                        color: #f75352;
                    }

                    &.bilibili:hover i {
                        color: #fd3c7a;
                    }
                }

                &:hover {
                    .social-icon {
                        background-color: #404040;
                    }

                    .social-label {
                        color: #bbb;
                    }

                    .scan-box {
                        visibility: visible;
                        opacity: 1;
                        top: -168px;
                    }
                }

                .social-label {
                    font-size: 12px;
                    color: #777;
                    white-space: nowrap;
                    transition: color 0.3s ease;
                }

                /* Scan Box Popup */
                .scan-box {
                    position: absolute;
                    top: -168px;
                    left: 50%;
                    transform: translateX(-50%);
                    background-color: #404040;
                    padding: 20px;
                    border-radius: 8px;
                    visibility: hidden;
                    opacity: 0;
                    transition: all 0.3s ease;
                    z-index: 99;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

                    .scan-content {
                        display: flex;
                        gap: 30px;
                    }

                    .scan-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        img {
                            width: 90px;
                            height: 90px;
                            border-radius: 4px;
                            margin-bottom: 8px;
                        }

                        p,
                        a {
                            font-size: 12px;
                            color: #999;
                            text-decoration: none;
                            white-space: nowrap;
                            line-height: 1.2;
                            transition: color 0.3s;
                        }

                        a:hover {
                            color: #0092ff;
                            text-decoration: underline;
                        }
                    }

                    .scan-arrow {
                        position: absolute;
                        bottom: -20px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 0;
                        height: 0;
                        border: 10px solid #404040;
                        border-color: #404040 transparent transparent transparent;
                    }
                }
            }
        }
    }
}
</style>
